"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getPageTrackingMetadata: function() {
        return getPageTrackingMetadata;
    },
    useAnalytics: function() {
        return useAnalytics;
    },
    useGetPreviousEventId: function() {
        return useGetPreviousEventId;
    },
    useTrackPageView: function() {
        return useTrackPageView;
    },
    useTrackVitals: function() {
        return useTrackVitals;
    }
});
const _react = require("react");
const _mktanalytics = require("@stripe-internal/mkt-analytics");
const _AnalyticsProvider = require("./AnalyticsProvider");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function getPageTrackingMetadata(pageId, root) {
    let title = root.dataset.pageTitle;
    if (typeof title !== 'string' || title.length === 0) {
        title = document.title;
    }
    return {
        id: pageId,
        title,
        path: location.pathname,
        path_with_qs: location.pathname + location.search,
        referrer: document.referrer
    };
}
function useAnalytics() {
    const client = (0, _AnalyticsProvider.useInternalAnalyticsClient)();
    return (0, _react.useMemo)(()=>({
            view (parameters) {
                client.trackPage(parameters);
            },
            action (eventName, parameters) {
                client.trackEvent(_object_spread_props(_object_spread({}, parameters), {
                    action: eventName
                }));
            },
            link (eventName, parameters) {
                client.trackEvent(_object_spread_props(_object_spread({}, parameters), {
                    action: eventName
                }));
            },
            modal (eventName, parameters) {
                client.trackEvent(_object_spread_props(_object_spread({}, parameters), {
                    action: eventName
                }));
            },
            track (eventName, parameters) {
                client.trackEvent(_object_spread_props(_object_spread({}, parameters), {
                    action: eventName
                }));
            },
            vitals (parameters) {
                var _client_trackVitals;
                (_client_trackVitals = client.trackVitals) === null || _client_trackVitals === void 0 ? void 0 : _client_trackVitals.call(client, parameters);
            },
            reportExperimentExposure (experimentTreatment, pageId) {
                const { experimentId, variantId, arbId } = experimentTreatment;
                client.setExperimentTreatment({
                    experimentId,
                    variantId,
                    arbId,
                    trackingMetadata: getPageTrackingMetadata(pageId, document.documentElement)
                });
            }
        }), [
        client
    ]);
}
function useGetPreviousEventId() {
    const client = (0, _AnalyticsProvider.useInternalAnalyticsClient)();
    // XXX: It is critical that this is the _legacy_ (analytics.event) provider,
    // not the newer AEL provider.  The backend data sets that rely on this value
    // still use the old system.  See #ir-bumper-portion
    return (0, _react.useMemo)(()=>{
        var _client_config;
        const legacyStripeAnalyticsProvider = (_client_config = client.config) === null || _client_config === void 0 ? void 0 : _client_config.providers.find((provider)=>provider instanceof _mktanalytics.LegacyStripeAnalyticsProvider);
        if (!legacyStripeAnalyticsProvider) {
            return null;
        }
        return legacyStripeAnalyticsProvider.analyticsReporter.getPreviousEventId();
    }, [
        client
    ]);
}
function useTrackPageView(label) {
    const { view } = useAnalytics();
    const hasTracked = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!hasTracked.current) {
            const pageMetadata = getPageTrackingMetadata(label, document.documentElement);
            view(pageMetadata);
            hasTracked.current = true;
        }
    }, [
        label,
        view
    ]);
}
function useTrackVitals(which) {
    const { vitals } = useAnalytics();
    const hasTracked = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!hasTracked.current) {
            vitals(which);
            hasTracked.current = true;
        }
    }, [
        which,
        vitals
    ]);
}

//# sourceMappingURL=hooks.js.map